globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.MainNavigation = (function() {

  function MainNavigation() {
    this.$mainNavigation = $('.main-navigation');
    this.init();
  }

  MainNavigation.prototype = {
    init: function(){
      // Dropdown custom integration
      this.$mainNavigation.find('.main-navigation-item.item-with-hover-dropdown').on('mouseenter', function(){
        var $this = $(this);
        setTimeout(function() {
          $this.find('.main-navigation-dropdown').stop(true).addClass('in').show();
        }, 0);
      }).on('mouseleave', function(){
        var $this = $(this);
        setTimeout(function(){
          $this.find('.main-navigation-dropdown').stop(true).removeClass('in').addClass('out');
          setTimeout(function(){
            $this.find('.main-navigation-dropdown').stop(true).removeClass('out').hide();
          }, 200);
        }, 0);
      });

      // Toggle active link on click for reactive behavior
      this.$mainNavigation.on('click', '.main-navigation-item > a[href]', function() {
        var $this = $(this),
            $item = $this.parent();

        $this.tooltip('hide');

        if(!$item.hasClass('active')) {
          $('.main-navigation-item').removeClass('active');
          $item.addClass('active');
        }
      });
    }
  }

  return MainNavigation;

})();
